export const getToken = () => {
  const token = localStorage.getItem("accessToken");
  return token ? JSON.parse(token) : null;
};

export const setToken = (access, refresh) => {
  localStorage.setItem(
    "accessToken",
    JSON.stringify({ token: access, refresh })
  );
};

export const clearToken = () => {
  localStorage.removeItem("accessToken");
};